/*
 * @Description: 加解密 整合
 * @Author: ke wen
 * @Date: 2021-02-25 11:04:51
 * @LastEditTime: 2021-03-09 10:35:14
 * @LastEditors: LastEditors
 * @Reference: 
 */

import Storage from './storage'
import { Decrypt, Encrypt } from './AES.js'
import { getToken } from '@/utils/auth'
import fun from './fun'
import router from '@/router'
import {Toast} from 'vant'
import storage from './storage'
import { JSEncrypt } from "encryptlong"
import store from '@/store'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
var visitorId = '';
(async () => {
    const fp = await FingerprintJS.load();
    const result =await fp.get();
    visitorId = result.visitorId;
})();

// 获取加密内容
export function getEncrypt(config,noEncrypt=false) {
    let data = JSON.parse(JSON.stringify(config.data)),
        sessionData = Storage.get('sessionData') ? Storage.get('sessionData') : null,
        aesPassword = Storage.get('aesPassword') ? Storage.get('aesPassword') : null,
        keyList = Storage.get('keyList');
    let param = {
            sys: {
                deviceId:visitorId,
                method: config.url.split(config.baseURL)[0],
                charset: "UTF-8",
                safeType: 'AES-RSA2-SIGN',
                appType: 'dangjia_h5',
                appVerName: store.getters.appVerName,
                appVerCode: store.getters.appVerCode,
                safeAccessDebug: false,
                timestamp:Math.floor((new Date().getTime())/1000),
                sessionKey:sessionData?sessionData.sessionKey:undefined
            },
            biz: data
        };
    
    if (param.biz.accessToken) {
        param.sys.accessToken = param.biz.accessToken
    }
    // if(['development','test'].includes(process.env.VUE_APP_ENV || process.env.NODE_ENV)){
    //     param.sys.safeAccessDebug = true
    //     param.sys.safeType = ''
    // }
    if (data.safeType) {
        param.sys.safeType = data.safeType
        delete param.biz.safeType
    }
    if (Storage.get('deBug')){
        param.sys.safeAccessDebug = true
        param.sys.safeType = ''
    }
    // console.log(param)
    if(noEncrypt){
        return param
    }
    if (param.sys.safeType == 'RSA' && sessionData) {
        let {serverPublicKey,sessionKey} = sessionData
        delete param.biz.serverPublicKey;
        delete param.biz.sessionKey;
        param.biz.clientPublicKey = keyList.public
        let encryptStr = new JSEncrypt();
        encryptStr.setPublicKey(serverPublicKey); // 设置 加密公钥
        let data = encryptStr.encryptLong(JSON.stringify(param));  // 进行加密
        param = {
            safeType: 'RSA',
            sessionKey: sessionKey,
            encryptedData: data,
        }
    } else if (param.sys.safeType == 'AES' && aesPassword) {
        let { sessionKey } = sessionData
        let data = Encrypt(JSON.stringify(param), aesPassword)
        param = {
            safeType: 'AES',
            sessionKey: sessionKey,
            encryptedData: data,
        }
    } else if (param.sys.safeType == 'AES-RSA2-SIGN' && sessionData && aesPassword) {
        let { sessionKey } = sessionData
        let data = Encrypt(JSON.stringify(param), aesPassword)
        param = {
            safeType: 'AES-RSA2-SIGN',
            sessionKey: sessionKey,
            encryptedData: data,
        }
        param.sign = fun.getCode(data)
    }
    return param
}


// 获取解密内容
export function getDecrypt(response) {
    if (response.status == 200) {
        let configData = JSON.parse(response.config.data),
            data = response.data,
            aesPassword = Storage.get('aesPassword') ? Storage.get('aesPassword') : null;
        //  console.log(configData)
        if (data.code == '00000000') {
            if (configData.safeType == 'AES') {
                data.data = JSON.parse(Decrypt(data.data, aesPassword))
            } else if (configData.safeType == 'RSA') {
                let encryptStr = new JSEncrypt();           //rsa解密
                encryptStr.setPrivateKey(Storage.get('keyList').private)
                data.data = JSON.parse(encryptStr.decrypt(data.data))
            } else if (configData.safeType == 'AES-RSA2-SIGN') {
                data.data = JSON.parse(Decrypt(data.data,aesPassword)||'null')
            } else {

            }
        }else if(['10301009','10301001','10301010','10301008'].includes(data.code)){
            // 10301009 aes解密失败 10301001 会话无效 10301010 会话未握手
            Toast(data.msg+'请重新进入页面')
            Storage.remove('keyList')
            Storage.remove('aesPassword')
            Storage.remove('sessionData')
            setTimeout(() => {
                fun.disposeSession()
            }, 1000);
        }else if(data.code == "10302006"){
            // router.replace('/login') 10302006 登录失效
            Toast(data.msg)
        }else if (data.code == "10103003") {    //触发图形验证
            store.dispatch('app/getVerifyImg',data.errInfo.value)
        }else if (data.code == "10103003") {    //调用次数过多，需要验证

        }
        return data
    } else {
        return response.status
    }
}
